<template>
	<div class="panel schedule">
		<div class="container">
			<div class="panel_header">
				<div class="row align-items-end">
					<div class="col-12">
						<h2 v-if="block.block_title === null">
							{{ $t('schedule') }} {{ fetchedData.type_titles.title_genitive }}
						</h2>
						<h2 v-else>
							{{ block.block_title }}
						</h2>
					</div>
				</div>
				<!-- <nuxt-link class="panel_control" to="#"></nuxt-link> -->
			</div>

			<ul class="schedule_list">
				<li
					v-for="(item, index) in this.block.items"
					:key="index"
					class="row d-flex align-self-center justify-content-start"
				>
					<div class="col-12 col-sm-12 col-lg-12">
						<div class="row schedule_data">
							<div class="col-12 col-sm-4">
								<div class="schedule_time">
									{{ item.time }}
								</div>
							</div>
							<div class="col-12 col-sm-8">
								<div class="schedule_about">
									<div class="title">
										{{ item.name }}
									</div>
									<p class="description" />
								</div>
							</div>
						</div>
					</div>
				</li>
			</ul>

			<div class="panel_footer">
				<div class="row">
					<div class="col-12">
						<a v-if="block.registration_button_text === null"
							v-scroll-to="'#empty-registration'"
							href="#"
							class="btn btn-primary"
						>{{ $t('registration-on') }} {{ fetchedData.type_titles.title_dative }}</a>
						<a v-else
						v-scroll-to="'#empty-registration'"
						href="#"
						class="btn btn-primary"
						>{{ block.registration_button_text }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PanelConferenceScheduleTwo',
	props: ['block', 'fetchedData', 'index'],
};
</script>

<style lang="scss">
	@import "~/assets/styles/components/home/panel-schedule";
</style>

<i18n lang="yaml">
ru:
  schedule: "Расписание"
  registration-on: "Регистрация на"
en:
  schedule: "Schedule"
  registration-on: "Registration for the"
</i18n>
